const LoadingAnimation = () => {
    return <div className="loading-animation">
        <div className="dee"></div>
        <div className="circle"></div>
    </div>
}

export default LoadingAnimation